<template>
  <el-dialog
    :title="editForm.id == null || editForm == '' ? $t('xin-zeng-xiang-bian-guan-li') : $t('bian-ji-xiang-bian-guan-li')"
    :visible="editFormVisible"
    :modal-append-to-body='false'
    :close-on-click-modal="false"
    :close-on-press-escape="editForm.id != null && editForm!=''"
    :before-close="clearEditForm">
    <el-form :inline="true" :model="editForm" ref="editForm" size="mini" class="edit_form" :rules="editFormRules">
      <el-form-item :label="$t('xiang-bian-ming-cheng')" :label-width="formLabelWidth" prop="name">
        <el-input v-model="editForm.name" autocomplete="off"></el-input>
      </el-form-item>
      <el-form-item :label="$t('deviceControl.operatorId')" :label-width="formLabelWidth" prop="operatorId">
        <el-cascader  size="mini"  ref="cascader"
                      :placeholder="$t('deviceControl.operatorId')" filterable
                      :options="this.setTreeDisable(this.operatorTree)"
                      :props="{checkStrictly:true,expandTrigger:'hover'}"
                      :show-all-levels="false"
                      change-on-select
                      @change='handleChangeOperator'
                      v-model="editForm.operatorId">
        </el-cascader>
      </el-form-item>
      <el-form-item :label="$t('zhan-dian-bian-hao')" :label-width="formLabelWidth" prop="stationCode">
        <el-select :placeholder="$t('operatingViewOperator.selectPlaceholder')" v-model="editForm.stationId" @change='getGunList' >
          <el-option v-for="item in stationEnum" :key="item.value"
                     v-bind:label="item.message" v-bind:value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item :label="$t('qiang-kou-bian-hao')" :label-width="formLabelWidth" prop="gunCodeList">
        <el-select :placeholder="$t('operatingViewOperator.selectPlaceholder')" multiple filterable
                   v-model="editForm.gunList" >
          <el-option v-for="item in gunEnum" :key="item.value"
                     v-bind:label="item.message" v-bind:value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item :label="$t('xiang-bian-fu-he-kw')" :label-width="formLabelWidth" prop="powerLoad">
        <el-input v-model="editForm.powerLoad" autocomplete="off"></el-input>
      </el-form-item>

      <el-form-item :label="$t('kai-fang-zhuang-tai')" :label-width="formLabelWidth" prop="isOpen">
        <el-select :placeholder="$t('operatingViewOperator.selectPlaceholder')" v-model="editForm.isOpen">
            <el-option v-for="item in yesOrNoEnum" :key="item.value"
                     v-bind:label="item.message" v-bind:value="item.value">
          </el-option>
        </el-select>
      </el-form-item>

      <!--隐藏id-->
      <el-form-item hidden style="display: none;" label="id" :label-width="formLabelWidth" prop="id">
        <el-input v-model="editForm.id" autocomplete="off"></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button size="small" @click="clearEditForm">{{ $t('qu-xiao') }}</el-button>
      <el-button size="small" type="primary" @click.native="editSubmit" :loading="editSubmitLoading">{{ $t('que-ding') }}</el-button>
    </div>
  </el-dialog>
</template>

<script>

  import {validateInput,isIntegerNotMust} from '../../../../common/validator'
  import stationApi from '@/module/resourceCenter/api/stationApi'
  import gunApi from '@/module/resourceCenter/api/gunApi'
  import api from '@/module/resourceCenter/api/gunBox'

  export default {
    name: "add",
    data(){
      return{
        stationEnum:'',
        gunEnum:'',
        openSiteSelect:{},
        editFormRules: {
          operatorId: [{required: true, message: this.$t('monitoringCenter.opsTreePlaceholder'), trigger: 'blur'}],
        },
        formLabelWidth: '150px',
      }
    },
    props:{
      yesOrNoEnum:'',
      editForm:{},
      editFormVisible:false,
      operatorForSelect:"",
      operatorTree:{
        type: Array,
        required: true
      },
      stationsForSelect:{},
      pileTypeForSelect:{},
      editSubmitLoading:false
    },
    watch: {
      'editFormVisible'(formVisible) {
        if (formVisible) {
          if (this.editForm.operatorId !== undefined) {

            console.log("运营商：" + this.editForm.operatorId)
            //  加载场站下拉列表
            stationApi.getStationEnumByOperatorId(this.editForm.operatorId).then((res) => {
              this.stationEnum = res
            })
            //  加载枪口下拉列表
            gunApi.getGunEnumByStationId(this.editForm.stationId).then((res) => {
              this.gunEnum = res
            })
          }
        }
      }
    },
    methods:{

      //  运营商下拉框发生变化
      handleChangeOperator(value) {
        let operatorId = value &&value.length >0 ? value[value.length-1] : ''
        this.editForm.operatorId= operatorId
        this.$refs.cascader.dropDownVisible = false
        this.$emit("operatorSelect", operatorId)
        stationApi.getStationEnumByOperatorId(operatorId).then((res) => {
          //  清空枪口列表
          this.gunEnum = '';
          this.stationEnum = res
        });
      },
      //  场站下拉框发生变化
      getGunList(value) {
        gunApi.getGunEnumByStationId(value).then((res) => {
          this.editForm.gunList = '';
          this.gunEnum = res
        });
      },

      //对数据进行授权过滤
      setTreeDisable(val) {
        //对 treeList 进行递归操作，禁止选中unchecked和unapproved
        val && val.forEach(item => {
          if ((item.checked && (item.checked === 'unchecked' || item.checked === 'unapproved'))) {
            item.disabled = true; // 如果类型为unchecked或者unapproved，就增加禁用选项
          }
          if (item.children) {
            this.setTreeDisable(item.children);
          }
        });
        return val;
      },
      clearEditForm(){
        let _this = this
        if(this.editForm.id == null || this.editForm == '') {
          this.$confirm(this.$t('paramMonitor.message18')).then(_ => {
            _this.$refs.editForm.clearValidate()
            _this.$emit('closeEditForm')
          }).catch(_ => {})
        }else {
          _this.$refs.editForm.clearValidate()
          _this.$emit('closeEditForm')
        }
      },
      editSubmit(){
        this.$emit("editSubmit", this.$refs.editForm)
      },
    }
  }
</script>

<style lang="less" scoped>
  /deep/ .edit_form {
    height: auto;
    .el-form-item--mini .el-form-item__content, .el-form-item--mini .el-form-item__label {
      line-height: 25px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/module/resourceCenter/page/gunBox/add.vue